import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconFile(props: IconContainerProps) {
    return <IconContainer {...props}>
        assignment
    </IconContainer>
}